const API_BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;
const API = `${API_BASE_URL}/api/v1`;

export const endpoint = {
  // Auth
  login: `${API}/auth/login/`,
  logout: `${API}/auth/logout/`,

  // Members
  getUsers: `${API}/member/`,
  createUser: `${API}/member/create/`,
  getUser: (userId: number) => `${API}/member/details/?user_id=${userId}`,
  updateUser: (userId: number) => `${API}/member/update/?user_id=${userId}`,
  getMemberTransactions: (userId: number) => `${API}/member/transactionhistory/?user_id=${userId}`,

  // Uploads
  uploadProfilePhoto: `${API}/upload/profilephoto/`,
  uploadFile: `${API}/upload/document/`,

  // Policies
  getMemberPolicies: (userId: number) => `${API}/policy/list/?user_id=${userId}`,
  createPolicy: `${API}/policy/create/`,
  getPolicy: (policyId: number) => `${API}/policy/details/?policy_id=${policyId}`,
  updatePolicy: (policyId: number) => `${API}/policy/update/?policy_id=${policyId}`,
  closePolicy: (policyId: number) => `${API}/policy/close/?policy_id=${policyId}`,
  createPayment: `${API}/policy/payment/`,
  getPolicyPayments: (policyId: number) => `${API}/policy/paymenthistory/?policy_id=${policyId}`,
  getPolicyInterest: (policyId: number) => `${API}/policy/interesthistory/?policy_id=${policyId}`,

  // Payments table
  getPaymentsManagement: `${API}/payment/`,

  // Loans
  getLoans: `${API}/loan/`,
  createLoan: `${API}/loan/create/`,
  getLoan: (loanId: number) => `${API}/loan/details/?loan_id=${loanId}`,
  createLoanPayment: (loanId: number) => `${API}/loan/repayment/?loan_id=${loanId}`,

  // Member balances (Paid by PMS)
  getBalances: `${API}/balance/`,
  getBalance: (userId: number) => `${API}/balance/details/?user_id=${userId}`,
  createBalancePayment: (userId: number) => `${API}/balance/repayment/?user_id=${userId}`,

  // Dashboard
  getDashboardSummary: `${API}/dashboard/summary/`,
  getDashboardTransactions: `${API}/dashboard/recenttransactions/`,
  getDashboardAttention: `${API}/dashboard/attentionrequired/`,
} as const;
